{
  "$id": "wealthlane://forms/vesting-template/orch",
  "$schema": "wealthlane://schemas/form-orch",
  "layout": [
    {
      "rowId": "vesting_template_identity",
      "fields": [
        {
          "scope": "#/properties/name",
          "field": "#/properties/name",
          "minCols": 4,
          "maxCols": 4,
          "minWidthPx": 280,
          "maxWidthPx": 800
        },
        {
          "scope": "#/properties/summary",
          "field": "#/properties/summary",
          "minCols": 4,
          "maxCols": 4,
          "minWidthPx": 280,
          "maxWidthPx": 800,
          "startNewRow": true
        }
      ]
    },
    {
      "rowId": "vesting_template_type_controls",
      "fields": [
        {
          "scope": "#/properties/vestingTypeId",
          "field": "#/properties/vestingTypeId",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 160,
          "maxWidthPx": 400
        },
        {
          "scope": "#/properties/loadingTypeId",
          "field": "#/properties/loadingTypeId",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 160,
          "maxWidthPx": 400
        },
        {
          "scope": "#/properties/endOfTheMonthTypeId",
          "field": "#/properties/endOfTheMonthTypeId",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 160,
          "maxWidthPx": 400,
          "startNewRow": true
        }
      ]
    },
    {
      "rowId": "vesting_template_specific_instruction",
      "fields": [
        {
          "scope": "#/properties/specificVestingInstruction",
          "field": "#/properties/specificVestingInstruction",
          "minCols": 4,
          "maxCols": 4,
          "minWidthPx": 280,
          "maxWidthPx": 800
        }
      ]
    },
    {
      "rowId": "vesting_template_details",
      "collapseWhenEmpty": true,
      "fields": [
        {
          "scope": "#/properties/periodStartDate",
          "field": "#/properties/periodStartDate",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 180,
          "maxWidthPx": 320,
          "startNewRow": true
        },
        {
          "scope": "#/properties/lengthInMonths",
          "field": "#/properties/lengthInMonths",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 96,
          "maxWidthPx": 220
        },
        {
          "scope": "#/properties/cliffPeriodHelperNote",
          "field": "#/properties/cliffPeriodHelperNote",
          "minCols": 4,
          "maxCols": 4,
          "minWidthPx": 280,
          "maxWidthPx": 800,
          "startNewRow": true
        },
        {
          "scope": "#/properties/vestsAfterInMonths",
          "field": "#/properties/vestsAfterInMonths",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 96,
          "maxWidthPx": 160
        },
        {
          "scope": "#/properties/amountOneInPercentage",
          "field": "#/properties/amountOneInPercentage",
          "minCols": 1,
          "maxCols": 1,
          "minWidthPx": 96,
          "maxWidthPx": 160
        },
        {
          "scope": "#/properties/intervalInMonths",
          "field": "#/properties/intervalInMonths",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 160,
          "maxWidthPx": 400
        }
      ]
    },
    {
      "rowId": "vesting_template_rounding",
      "divider": true,
      "collapseWhenEmpty": true,
      "fields": [
        {
          "scope": "#/properties/roundingTypeId",
          "field": "#/properties/roundingTypeId",
          "minCols": 2,
          "maxCols": 2,
          "minWidthPx": 160,
          "maxWidthPx": 400,
          "startNewRow": true
        }
      ]
    }
  ]
}
